import React from 'react';
import ReactDOM from 'react-dom';
import View from './webmailForgotPassword/View.jsx';
import DevLanguageSelector from './DevLanguageSelector.jsx';

export default ({
  element,
  props,
}) => {
  ReactDOM.render(
    <DevLanguageSelector {...props}>
      <View {...props} />
    </DevLanguageSelector>,
    element
  );
};
